function post(params) {
    return new Promise((resolve, reject) => {
        if (params.useMock) {
            params.url = `//127.0.0.1:5000/${params.url}`;
        }

        globalAjax.post(params.url, params.requestParams, (res) => {
            if (res.code === '0000') {
                resolve(res.data);
            } else {
                reject(res.msg);
            }
        });
    });
}

export {
    post
};
